import * as storage from '../localstorage/localstorage';
import { FROM_HISTORICO_KEY } from '../consts/system-const';
import DADOS_SIM from '../consts/consts';

const listaBemValues = DADOS_SIM.LISTA_BENS;

const sleep = (m) => new Promise((r) => setTimeout(r, m));
const SESSION_ID = 'sessionId';
const SESSION_KEY = 'session';
const CHAVE_SEG_MAIS = 'segMais';
const CHAVE_BROTO = 'broto';
const CHAVE_USER_BROTO = 'userBroto';
const AUTH = 'auth';
let SESSION = null;
export default class SessionService {
    static async saveSession(session) {
        this.setSession(session);
        /** Envia para a API */
        await sleep(500);
    }
    static async fetchSession() {
        /** Simula busca da API */
        if (this.getSessionId()) {
            this.setSession(storage.getData(SESSION_KEY));
        } else {
            this.clearSession();
        }
        await sleep(500);
    }

    static setSession(session) {
        SESSION = { ...SESSION, ...session };
        storage.saveData(SESSION_KEY, SESSION);
    }
    static getSession() {
        return SESSION;
    }
    /** Limpa sessao */
    static clearSession() {
        storage.removeData(SESSION_KEY);
        storage.removeData(SESSION_ID);
        SESSION = null;
    }

    static setSessionId(cotacaoId) {
        storage.saveData(SESSION_ID, cotacaoId);
    }
    static getSessionId() {
        return storage.getData(SESSION_ID);
    }

    /** Para SegMais */
    static getChaveSegMais() {
        return storage.getDataSession(CHAVE_SEG_MAIS);
    }
    static setChaveSegMais(chaveMob) {
        storage.saveDataSession(CHAVE_SEG_MAIS, chaveMob);
    }
    static clearChaveSegMais() {
        storage.removeDataSession(CHAVE_SEG_MAIS);
    }

    /** Para Broto */
    static getChaveBroto() {
        return storage.getDataSession(CHAVE_BROTO);
    }
    static setChaveBroto(codAcesso) {
        storage.saveDataSession(CHAVE_BROTO, codAcesso);
    }
    static clearChaveBroto() {
        storage.removeDataSession(CHAVE_BROTO);
    }
    static getUserBroto() {
        return storage.getDataSession(CHAVE_USER_BROTO);
    }
    static setUserBroto(userBroto) {
        storage.saveDataSession(CHAVE_USER_BROTO, userBroto);
    }
    static clearUserBroto() {
        storage.removeDataSession(CHAVE_USER_BROTO);
    }

    static getToken() {
        return storage.getDataUnsecure(AUTH);
    }
    static setToken(token) {
        storage.saveDataUnsecure(AUTH, token);
    }
    static clearToken() {
        storage.removeData(AUTH);
    }

    static clearHistorySessionAndFilterListaBens() {
        const newSession = {
            [FROM_HISTORICO_KEY]: false,
            [listaBemValues.THIS]: SESSION.listaBensFiltrados
                ? SESSION.listaBensFiltrados
                : SESSION[listaBemValues.THIS]
        };
        this.setSession(newSession);
        return newSession;
    }
}
